<div class="editor-section {{disabled ? 'editor-disabled' : ''}}">
    <query-table-selector [tableSetId]="sqlQueryBuild?.tableSetId"
                          (onFolderChange)="refreshFolder($event)"
                          (onTableClick)="insertTableNodeValue($event)"
                          (onColumnClick)="insertColumnNodeValue($event)">
    </query-table-selector>

    <div class="sql-editor-container">
        @if (!!extensions && !!specification) {
            <sql-editor [(ngModel)]="sqlCode"
                        [extensions]="extensions"
                        [specification]="specification">
            </sql-editor>
        }
    </div>
</div>